module.exports = __webpack_public_path__ + "media/images/pc/stores/kobe/kobe_concept_03-222ec06dfd7b2536e8ec77ad185f1019.jpg";